// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --primary: #1e7c88;
}
iframe {
    position: absolute;
    top: 0rem;
    left: 0rem;
    height: 100%;
    width: 100%;
    /* z-index: 20000; */
}

textarea {
    width: 100% !important;
    outline-color: rgb(235, 235, 235) !important;
    border: 1px solid rgb(235, 235, 235) !important;
    padding: 1rem !important;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
}
video {
    border-radius: 10px;
}
iframe {
    border-radius: 0.5rem;
    margin-bottom: 1rem;
}
.MuiCardHeader-content {
    color: #1e7c88;
    font-size: 2rem !important;
}
.logo {
    height: 1.5rem;
    width: 100%;
}
.color-primnary {
    background-color: var(--primary);
    color: var(--primary);
}
.text-primary {
    color: var(--primary) !important;
}
.side-space {
    padding-left: 6.5rem;
    padding-right: 6.5rem;
}
.ql-container {
    resize: vertical !important;
    height: 30vh !important;
    overflow-y: scroll;
}
.scroll {
    overflow-y: scroll !important;
}

.box {
    max-width: 41rem !important;
    overflow-x: initial;
    overflow-y: scroll !important;
}
.hidden {
    height: 0px !important;
    width: 0px !important;
    opacity: 0;
}
.float-end {
    float: inline-end;
}
.img-fit {
    max-height: 100%;
    width: 100%;
    object-fit: cover;
}
.img-contain {
    max-height: 100%;
    width: 100%;
    object-fit: contain;
}
.uploaded-img {
    border-radius: 10px;
    height: 10rem;
    width: 10rem;
    /* max-height: 100%; */
    width: 100%;
    object-fit: cover;
}
.ontent-body img {
    border-radius: 10px;
}
.img-box:hover .trash {
    opacity: 1;
}
.image-cover {
    background-color: rgba(24, 24, 24, 0.13);
    overflow: hidden !important;
    padding: 1rem;
    z-index: 1;
}
.icon-style {
    width: 20px;
}
/* carsul  */
.tag {
    text-align: center;
}
.slider-img-cont {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
}
.slick-next {
    right: 0rem;
    margin-right: 2rem;
}
.slick-prev {
    left: 0rem;
    z-index: 99;
}
.slick-prev:before {
    font-size: 50px !important;
    margin-left: 0rem;
}
.slick-next:before {
    font-size: 50px !important;
}

.img-fit-slide {
    /* margin-top: 3rem; */
    height: 80vh;
    width: 50%;
    overflow-y: scroll !important;
    object-fit: contain;
    display: flex;
    justify-content: center;
    align-items: center;
    background: black;
}
.slide-mid {
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
}
.center-center {
    height: 100%;
    width: 100%;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
}
.dashed {
    border: 1px dashed var(--primary);
}
audio {
    width: 95% !important;
}
.react-img:hover {
    transform: scale(1.5) !important;
}
.cursor-pointer {
    cursor: pointer !important;
}
.collapse {
    animation-name: example;
    animation-duration: 1s;
}
.img-messenger {
    height: 100%;
    max-width: 100%;
    object-fit: cover;
}
@keyframes example {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}
.lol {
    height: 2rem !important;
}
.filter-badge {
    padding: 0.6rem;
    border-radius: 2rem;
    background-color: rgba(30, 124, 136, 0.05);
}
.filter-badge-active {
    padding: 0.6rem;
    border-radius: 2rem;
    color: #ffffff;
    background-color: rgba(30, 124, 136, 1);
}
.overflow-x {
    width: 100% !important;
    overflow-x: scroll !important;
}
.overflow-x-full {
    display: flex;
    width: 90vw !important;
    overflow-x: scroll !important;
}
.border-bottom {
    border-bottom: 1px solid rgba(30, 124, 136, 0.322);
    padding-bottom: 0.5rem;
    margin-bottom: 1rem;
}
.overflw {
    height: 60vh;
    overflow-y: scroll;
    overflow-x: hidden;
    padding-right: 5px;
}
.overflw-inv {
    height: 80vh;
    overflow-y: scroll;
    overflow-x: hidden;
    padding-right: 5px;
}
.over {
    overflow-y: scroll;
    overflow-x: hidden;
}
.over-all {
    overflow-y: scroll;
    overflow-x: scroll;
}
::-webkit-scrollbar {
    width: 0px;
    height: 0px;
    background: #ffffff;
}
::-webkit-scrollbar-thumb {
    background: #1e7c88;
    height: 0px !important;
    padding: 0px;
}
.overflwNew {
    height: 100vh;
    overflow-y: scroll;
    overflow-x: hidden;
    padding-right: 5px;
}
.overflw::-webkit-scrollbar {
    width: 0.25rem;
    height: 0.25rem;
    background: #ffffff;
}
.overflw::-webkit-scrollbar-thumb {
    background: #1e7c88;
    height: 0.25rem !important;
    padding: 0.25rem;
}
.overflwNew::-webkit-scrollbar {
    width: 0.25rem;
    height: 0.25rem;
    background: #ffffff;
}
.overflwNew::-webkit-scrollbar-thumb {
    background: #1e7c88;
    height: 0.25rem !important;
    padding: 0.25rem;
}
.over::-webkit-scrollbar {
    width: 0.25rem;
    height: 0.25rem;
    background: #ffffff;
}

.over::-webkit-scrollbar-thumb {
    background: #1e7c88;
    height: 0.25rem !important;
    padding: 0.25rem;
    border-radius: 0.25rem;
}
.over-all::-webkit-scrollbar {
    width: 0.25rem;
    height: 0.5rem;
    background: #ffffff;
}

.over-all::-webkit-scrollbar-thumb {
    background: #1e7c88;
    height: 0.25rem !important;
    padding: 0.25rem;
    border-radius: 0.25rem;
}
.gallery-button {
    background-color: rgba(30, 124, 136, 0.05);
    border: 1px solid rgba(30, 124, 136, 1);
    color: rgba(30, 124, 136, 1);
    border-radius: 10px;
}
.dispimg {
    margin-left: -0.7rem;
    z-index: 200;
}

input[type='checkbox'] {
    display: none;
}

.imgcontainer img {
    transition: transform 0.25s ease;
    cursor: zoom-in;
}

input[type='checkbox']:checked ~ label > img {
    transform: scale(2);
    cursor: zoom-out;
    overflow: scroll !important;
}
.img-fit-slide::-webkit-scrollbar {
    width: 0.25rem;
    height: 0.25rem;
    background: #ffffff;
}
.img-fit-slide::-webkit-scrollbar-thumb {
    background: #1e7c88;
    height: 0.25rem !important;
    padding: 0.25rem;
}
.round {
    height: 12rem;
    width: 12rem;
    border-radius: 6rem;
}

.round-small {
    height: 3.5rem;
    width: 3.5rem;
    border-radius: 3rem;
}
.round-dash {
    height: 4rem;
    width: 4rem;
    border-radius: 3rem;
}
.round-esmall {
    height: 2.5rem;
    width: 2.5rem;
    border-radius: 3rem;
}
.round-eesmall {
    height: 1.6rem;
    width: 1.6rem;
    border-radius: 3rem;
}
.round-micro {
    height: 0.9rem;
    width: 0.9rem;
    border-radius: 3rem;
    border: 1px solid white;
}
.scroll-x {
    overflow-x: scroll !important;
    overflow-y: hidden !important;
}
.scroll-x::-webkit-scrollbar-thumb {
    background: #1e7c88;
    height: 1rem !important;
    padding: 1rem;
    border-radius: 1rem;
}
.scroll-x::-webkit-scrollbar {
    width: 0.25rem;
    height: 0.25rem;
    background: #ffffff;
}
.leftSwipe {
    transform: translate(-19rem, -2ex);
    transition: transform 500ms ease-in-out 25ms;
}
.rightSwipe {
    transform: translate(0rem, -2ex);
    transition: transform 500ms ease-in-out 25ms;
}
.rotateimg180 {
    transform: rotate(180deg);
}

.scroll-wrapper {
    overflow: auto;
}

.scroll-wrapper::-webkit-scrollbar {
    width: 0.5rem;
    height: 0.5rem;
    background: #ffffff;
}
.scroll-wrapper::-webkit-scrollbar-thumb {
    background: #d2d2d2;
    height: 0.5rem !important;
    padding: 0.5rem;
}
.d-none {
    display: none !important;
}
.rmdp-container {
    display: none !important;
}
@media only screen and (max-width: 600px) {
    .overflow-x-full {
        display: flex;
    }
    .side-space {
        padding-left: 1rem;
        padding-right: 1rem;
    }
    .slick-next {
        right: -1.2rem;
    }
    .slick-prev {
        left: -1.5rem;
    }
    .slick-prev:before {
        font-size: 30px !important;
        margin-left: -0.3rem;
    }
    .slick-next:before {
        font-size: 30px !important;
        margin-right: -0.7rem;
    }
    .round {
        height: 6rem;
        width: 6rem;
        border-radius: 6rem;
    }
}
@media only screen and (max-width: 1240px) {
    .css-18p9tjl {
        padding-left: 0rem;
        padding-right: 0rem;
    }
}
pre {
    margin: 0;
    font-family: 'Roboto', sans-serif;
    font-weight: 400;
    font-size: 1rem;
    line-height: 1.5;
}
.fs-14 {
    font-size: 14px !important;
}

/* Firefox scrollbar styles */
/* .scroll,
.box,
.scroll-x,
.ql-container,
.overflw,
.overflw-inv,
.over,
.over-all,
.scroll-wrapper {
    scrollbar-width: thin;
    scrollbar-color: #1e7c88 #ffffff;
} */
.hover-scroll {
    overflow: hidden;
    transition: overflow 0.3s ease-in-out;
}

.hover-scroll:hover {
    overflow: auto;
}

.hover-scroll::-webkit-scrollbar {
    width: 8px;
}

.hover-scroll::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/css/App.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,YAAY;IACZ,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,sBAAsB;IACtB,4CAA4C;IAC5C,+CAA+C;IAC/C,wBAAwB;IACxB,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,qBAAqB;IACrB,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,0BAA0B;AAC9B;AACA;IACI,cAAc;IACd,WAAW;AACf;AACA;IACI,gCAAgC;IAChC,qBAAqB;AACzB;AACA;IACI,gCAAgC;AACpC;AACA;IACI,oBAAoB;IACpB,qBAAqB;AACzB;AACA;IACI,2BAA2B;IAC3B,uBAAuB;IACvB,kBAAkB;AACtB;AACA;IACI,6BAA6B;AACjC;;AAEA;IACI,2BAA2B;IAC3B,mBAAmB;IACnB,6BAA6B;AACjC;AACA;IACI,sBAAsB;IACtB,qBAAqB;IACrB,UAAU;AACd;AACA;IACI,iBAAiB;AACrB;AACA;IACI,gBAAgB;IAChB,WAAW;IACX,iBAAiB;AACrB;AACA;IACI,gBAAgB;IAChB,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,aAAa;IACb,YAAY;IACZ,sBAAsB;IACtB,WAAW;IACX,iBAAiB;AACrB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,UAAU;AACd;AACA;IACI,wCAAwC;IACxC,2BAA2B;IAC3B,aAAa;IACb,UAAU;AACd;AACA;IACI,WAAW;AACf;AACA,YAAY;AACZ;IACI,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,WAAW;AACf;AACA;IACI,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,UAAU;IACV,WAAW;AACf;AACA;IACI,0BAA0B;IAC1B,iBAAiB;AACrB;AACA;IACI,0BAA0B;AAC9B;;AAEA;IACI,sBAAsB;IACtB,YAAY;IACZ,UAAU;IACV,6BAA6B;IAC7B,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;AACrB;AACA;IACI,wBAAwB;IACxB,kCAAkC;IAClC,8BAA8B;AAClC;AACA;IACI,YAAY;IACZ,WAAW;IACX,wBAAwB;IACxB,kCAAkC;IAClC,8BAA8B;AAClC;AACA;IACI,iCAAiC;AACrC;AACA;IACI,qBAAqB;AACzB;AACA;IACI,gCAAgC;AACpC;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,uBAAuB;IACvB,sBAAsB;AAC1B;AACA;IACI,YAAY;IACZ,eAAe;IACf,iBAAiB;AACrB;AACA;IACI;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;AACJ;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,eAAe;IACf,mBAAmB;IACnB,0CAA0C;AAC9C;AACA;IACI,eAAe;IACf,mBAAmB;IACnB,cAAc;IACd,uCAAuC;AAC3C;AACA;IACI,sBAAsB;IACtB,6BAA6B;AACjC;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,6BAA6B;AACjC;AACA;IACI,kDAAkD;IAClD,sBAAsB;IACtB,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,UAAU;IACV,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,YAAY;AAChB;AACA;IACI,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,cAAc;IACd,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,0BAA0B;IAC1B,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,0BAA0B;IAC1B,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,0BAA0B;IAC1B,gBAAgB;IAChB,sBAAsB;AAC1B;AACA;IACI,cAAc;IACd,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,0BAA0B;IAC1B,gBAAgB;IAChB,sBAAsB;AAC1B;AACA;IACI,0CAA0C;IAC1C,uCAAuC;IACvC,4BAA4B;IAC5B,mBAAmB;AACvB;AACA;IACI,oBAAoB;IACpB,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gCAAgC;IAChC,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,2BAA2B;AAC/B;AACA;IACI,cAAc;IACd,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,0BAA0B;IAC1B,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,6BAA6B;IAC7B,6BAA6B;AACjC;AACA;IACI,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,kCAAkC;IAClC,4CAA4C;AAChD;AACA;IACI,gCAAgC;IAChC,4CAA4C;AAChD;AACA;IAKI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;AACnB;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,wBAAwB;AAC5B;AACA;IACI;QACI,aAAa;IACjB;IACA;QACI,kBAAkB;QAClB,mBAAmB;IACvB;IACA;QACI,cAAc;IAClB;IACA;QACI,aAAa;IACjB;IACA;QACI,0BAA0B;QAC1B,oBAAoB;IACxB;IACA;QACI,0BAA0B;QAC1B,qBAAqB;IACzB;IACA;QACI,YAAY;QACZ,WAAW;QACX,mBAAmB;IACvB;AACJ;AACA;IACI;QACI,kBAAkB;QAClB,mBAAmB;IACvB;AACJ;AACA;IACI,SAAS;IACT,iCAAiC;IACjC,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,0BAA0B;AAC9B;;AAEA,6BAA6B;AAC7B;;;;;;;;;;;GAWG;AACH;IACI,gBAAgB;IAChB,qCAAqC;AACzC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,oCAAoC;IACpC,mBAAmB;AACvB","sourcesContent":[":root {\n    --primary: #1e7c88;\n}\niframe {\n    position: absolute;\n    top: 0rem;\n    left: 0rem;\n    height: 100%;\n    width: 100%;\n    /* z-index: 20000; */\n}\n\ntextarea {\n    width: 100% !important;\n    outline-color: rgb(235, 235, 235) !important;\n    border: 1px solid rgb(235, 235, 235) !important;\n    padding: 1rem !important;\n    font-family: 'Roboto';\n    font-style: normal;\n    font-weight: 400;\n}\nvideo {\n    border-radius: 10px;\n}\niframe {\n    border-radius: 0.5rem;\n    margin-bottom: 1rem;\n}\n.MuiCardHeader-content {\n    color: #1e7c88;\n    font-size: 2rem !important;\n}\n.logo {\n    height: 1.5rem;\n    width: 100%;\n}\n.color-primnary {\n    background-color: var(--primary);\n    color: var(--primary);\n}\n.text-primary {\n    color: var(--primary) !important;\n}\n.side-space {\n    padding-left: 6.5rem;\n    padding-right: 6.5rem;\n}\n.ql-container {\n    resize: vertical !important;\n    height: 30vh !important;\n    overflow-y: scroll;\n}\n.scroll {\n    overflow-y: scroll !important;\n}\n\n.box {\n    max-width: 41rem !important;\n    overflow-x: initial;\n    overflow-y: scroll !important;\n}\n.hidden {\n    height: 0px !important;\n    width: 0px !important;\n    opacity: 0;\n}\n.float-end {\n    float: inline-end;\n}\n.img-fit {\n    max-height: 100%;\n    width: 100%;\n    object-fit: cover;\n}\n.img-contain {\n    max-height: 100%;\n    width: 100%;\n    object-fit: contain;\n}\n.uploaded-img {\n    border-radius: 10px;\n    height: 10rem;\n    width: 10rem;\n    /* max-height: 100%; */\n    width: 100%;\n    object-fit: cover;\n}\n.ontent-body img {\n    border-radius: 10px;\n}\n.img-box:hover .trash {\n    opacity: 1;\n}\n.image-cover {\n    background-color: rgba(24, 24, 24, 0.13);\n    overflow: hidden !important;\n    padding: 1rem;\n    z-index: 1;\n}\n.icon-style {\n    width: 20px;\n}\n/* carsul  */\n.tag {\n    text-align: center;\n}\n.slider-img-cont {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100%;\n    width: 100%;\n}\n.slick-next {\n    right: 0rem;\n    margin-right: 2rem;\n}\n.slick-prev {\n    left: 0rem;\n    z-index: 99;\n}\n.slick-prev:before {\n    font-size: 50px !important;\n    margin-left: 0rem;\n}\n.slick-next:before {\n    font-size: 50px !important;\n}\n\n.img-fit-slide {\n    /* margin-top: 3rem; */\n    height: 80vh;\n    width: 50%;\n    overflow-y: scroll !important;\n    object-fit: contain;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background: black;\n}\n.slide-mid {\n    display: flex !important;\n    justify-content: center !important;\n    align-items: center !important;\n}\n.center-center {\n    height: 100%;\n    width: 100%;\n    display: flex !important;\n    justify-content: center !important;\n    align-items: center !important;\n}\n.dashed {\n    border: 1px dashed var(--primary);\n}\naudio {\n    width: 95% !important;\n}\n.react-img:hover {\n    transform: scale(1.5) !important;\n}\n.cursor-pointer {\n    cursor: pointer !important;\n}\n.collapse {\n    animation-name: example;\n    animation-duration: 1s;\n}\n.img-messenger {\n    height: 100%;\n    max-width: 100%;\n    object-fit: cover;\n}\n@keyframes example {\n    from {\n        opacity: 0;\n    }\n    to {\n        opacity: 1;\n    }\n}\n.lol {\n    height: 2rem !important;\n}\n.filter-badge {\n    padding: 0.6rem;\n    border-radius: 2rem;\n    background-color: rgba(30, 124, 136, 0.05);\n}\n.filter-badge-active {\n    padding: 0.6rem;\n    border-radius: 2rem;\n    color: #ffffff;\n    background-color: rgba(30, 124, 136, 1);\n}\n.overflow-x {\n    width: 100% !important;\n    overflow-x: scroll !important;\n}\n.overflow-x-full {\n    display: flex;\n    width: 90vw !important;\n    overflow-x: scroll !important;\n}\n.border-bottom {\n    border-bottom: 1px solid rgba(30, 124, 136, 0.322);\n    padding-bottom: 0.5rem;\n    margin-bottom: 1rem;\n}\n.overflw {\n    height: 60vh;\n    overflow-y: scroll;\n    overflow-x: hidden;\n    padding-right: 5px;\n}\n.overflw-inv {\n    height: 80vh;\n    overflow-y: scroll;\n    overflow-x: hidden;\n    padding-right: 5px;\n}\n.over {\n    overflow-y: scroll;\n    overflow-x: hidden;\n}\n.over-all {\n    overflow-y: scroll;\n    overflow-x: scroll;\n}\n::-webkit-scrollbar {\n    width: 0px;\n    height: 0px;\n    background: #ffffff;\n}\n::-webkit-scrollbar-thumb {\n    background: #1e7c88;\n    height: 0px !important;\n    padding: 0px;\n}\n.overflwNew {\n    height: 100vh;\n    overflow-y: scroll;\n    overflow-x: hidden;\n    padding-right: 5px;\n}\n.overflw::-webkit-scrollbar {\n    width: 0.25rem;\n    height: 0.25rem;\n    background: #ffffff;\n}\n.overflw::-webkit-scrollbar-thumb {\n    background: #1e7c88;\n    height: 0.25rem !important;\n    padding: 0.25rem;\n}\n.overflwNew::-webkit-scrollbar {\n    width: 0.25rem;\n    height: 0.25rem;\n    background: #ffffff;\n}\n.overflwNew::-webkit-scrollbar-thumb {\n    background: #1e7c88;\n    height: 0.25rem !important;\n    padding: 0.25rem;\n}\n.over::-webkit-scrollbar {\n    width: 0.25rem;\n    height: 0.25rem;\n    background: #ffffff;\n}\n\n.over::-webkit-scrollbar-thumb {\n    background: #1e7c88;\n    height: 0.25rem !important;\n    padding: 0.25rem;\n    border-radius: 0.25rem;\n}\n.over-all::-webkit-scrollbar {\n    width: 0.25rem;\n    height: 0.5rem;\n    background: #ffffff;\n}\n\n.over-all::-webkit-scrollbar-thumb {\n    background: #1e7c88;\n    height: 0.25rem !important;\n    padding: 0.25rem;\n    border-radius: 0.25rem;\n}\n.gallery-button {\n    background-color: rgba(30, 124, 136, 0.05);\n    border: 1px solid rgba(30, 124, 136, 1);\n    color: rgba(30, 124, 136, 1);\n    border-radius: 10px;\n}\n.dispimg {\n    margin-left: -0.7rem;\n    z-index: 200;\n}\n\ninput[type='checkbox'] {\n    display: none;\n}\n\n.imgcontainer img {\n    transition: transform 0.25s ease;\n    cursor: zoom-in;\n}\n\ninput[type='checkbox']:checked ~ label > img {\n    transform: scale(2);\n    cursor: zoom-out;\n    overflow: scroll !important;\n}\n.img-fit-slide::-webkit-scrollbar {\n    width: 0.25rem;\n    height: 0.25rem;\n    background: #ffffff;\n}\n.img-fit-slide::-webkit-scrollbar-thumb {\n    background: #1e7c88;\n    height: 0.25rem !important;\n    padding: 0.25rem;\n}\n.round {\n    height: 12rem;\n    width: 12rem;\n    border-radius: 6rem;\n}\n\n.round-small {\n    height: 3.5rem;\n    width: 3.5rem;\n    border-radius: 3rem;\n}\n.round-dash {\n    height: 4rem;\n    width: 4rem;\n    border-radius: 3rem;\n}\n.round-esmall {\n    height: 2.5rem;\n    width: 2.5rem;\n    border-radius: 3rem;\n}\n.round-eesmall {\n    height: 1.6rem;\n    width: 1.6rem;\n    border-radius: 3rem;\n}\n.round-micro {\n    height: 0.9rem;\n    width: 0.9rem;\n    border-radius: 3rem;\n    border: 1px solid white;\n}\n.scroll-x {\n    overflow-x: scroll !important;\n    overflow-y: hidden !important;\n}\n.scroll-x::-webkit-scrollbar-thumb {\n    background: #1e7c88;\n    height: 1rem !important;\n    padding: 1rem;\n    border-radius: 1rem;\n}\n.scroll-x::-webkit-scrollbar {\n    width: 0.25rem;\n    height: 0.25rem;\n    background: #ffffff;\n}\n.leftSwipe {\n    transform: translate(-19rem, -2ex);\n    transition: transform 500ms ease-in-out 25ms;\n}\n.rightSwipe {\n    transform: translate(0rem, -2ex);\n    transition: transform 500ms ease-in-out 25ms;\n}\n.rotateimg180 {\n    -webkit-transform: rotate(180deg);\n    -moz-transform: rotate(180deg);\n    -ms-transform: rotate(180deg);\n    -o-transform: rotate(180deg);\n    transform: rotate(180deg);\n}\n\n.scroll-wrapper {\n    overflow: auto;\n}\n\n.scroll-wrapper::-webkit-scrollbar {\n    width: 0.5rem;\n    height: 0.5rem;\n    background: #ffffff;\n}\n.scroll-wrapper::-webkit-scrollbar-thumb {\n    background: #d2d2d2;\n    height: 0.5rem !important;\n    padding: 0.5rem;\n}\n.d-none {\n    display: none !important;\n}\n.rmdp-container {\n    display: none !important;\n}\n@media only screen and (max-width: 600px) {\n    .overflow-x-full {\n        display: flex;\n    }\n    .side-space {\n        padding-left: 1rem;\n        padding-right: 1rem;\n    }\n    .slick-next {\n        right: -1.2rem;\n    }\n    .slick-prev {\n        left: -1.5rem;\n    }\n    .slick-prev:before {\n        font-size: 30px !important;\n        margin-left: -0.3rem;\n    }\n    .slick-next:before {\n        font-size: 30px !important;\n        margin-right: -0.7rem;\n    }\n    .round {\n        height: 6rem;\n        width: 6rem;\n        border-radius: 6rem;\n    }\n}\n@media only screen and (max-width: 1240px) {\n    .css-18p9tjl {\n        padding-left: 0rem;\n        padding-right: 0rem;\n    }\n}\npre {\n    margin: 0;\n    font-family: 'Roboto', sans-serif;\n    font-weight: 400;\n    font-size: 1rem;\n    line-height: 1.5;\n}\n.fs-14 {\n    font-size: 14px !important;\n}\n\n/* Firefox scrollbar styles */\n/* .scroll,\n.box,\n.scroll-x,\n.ql-container,\n.overflw,\n.overflw-inv,\n.over,\n.over-all,\n.scroll-wrapper {\n    scrollbar-width: thin;\n    scrollbar-color: #1e7c88 #ffffff;\n} */\n.hover-scroll {\n    overflow: hidden;\n    transition: overflow 0.3s ease-in-out;\n}\n\n.hover-scroll:hover {\n    overflow: auto;\n}\n\n.hover-scroll::-webkit-scrollbar {\n    width: 8px;\n}\n\n.hover-scroll::-webkit-scrollbar-thumb {\n    background-color: rgba(0, 0, 0, 0.2);\n    border-radius: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
